<template>
  <div class="content scroll-y">
    <div class="part-container">
      <div class="part-head f--c">
        <h5 class="part-title">定制信息</h5>
      </div>
      <p class="typeTitle">{{customeDetail.type === 1? 'Customize on Demand' : 'Print on Demand'}}</p>
      <div class="part-main">
        <el-row>
          <el-col class="item-box" :span="8">
            <div class="label">Product Name</div>
            <div class="info">{{customeDetail.productName ||'-'}}</div>
          </el-col>
          <el-col class="item-box" :span="8">
            <div class="label">Contact Email</div>
            <div class="info">{{customeDetail.email ||'-'}}</div>
          </el-col>
          <el-col class="item-box" :span="8">
            <div class="label">Phone Number</div>
            <div class="info">{{customeDetail.phoneNumber ||'-'}}</div>
          </el-col>
        </el-row>
        <el-row v-if="customeDetail.type === 2">
          <el-col :span="22">
            <div class="label">Clothing type</div>
            <div class="f printImageBox fw-w">
              <div v-for="value in customeDetail.podStyle.split(',')" :key="value">
                <img :src="value | podStyleImage" style="width: 110px;height:96px">
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
           <el-col class="item-box" :span="8">
            <div class="label">Reference Linking</div>
            <div class="info">{{customeText.referenceLinking ||'-'}}</div>
          </el-col>
          <el-col class="item-box" :span="8">
            <div class="label">Estimated Order Quantity</div>
            <div class="info">{{customeDetail.estimatedOrderQuantity ||'-'}}</div>
          </el-col>
          <el-col class="item-box" :span="8">
            <div class="label">Color Quantity</div>
            <div class="info">{{customeDetail.colorQuantity ||'-'}}</div>
          </el-col>
        </el-row>
        <el-row>
           <el-col class="item-box" :span="8">
            <div class="label">Size Quantity(per color)</div>
            <div class="info">{{customeDetail.sizeQuantity ||'-'}}</div>
          </el-col>
          <el-col class="item-box" :span="8">
            <div class="label">Custom Order Id</div>
            <div class="info">{{customeDetail.customOrderId ||'-'}}</div>
          </el-col>
          <el-col class="item-box" :span="8">
            <div class="label">Channel Type</div>
            <div class="info">{{customeDetail.channelType ||'-'}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="item-box" :span="24">
            <div class="label">Material</div>
            <div v-if="customeDetail.material" class="f fw-w">
              <div v-for="item in customeDetail.material.split(',')" :key="item" class="materialItem">{{item | materialHandle}}</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="item-box" :span="24">
            <div class="label">Description</div>
            <div class="info">{{customeText.description ||'-'}}</div>
          </el-col>
        </el-row>
        <p class="image-part-title">Image</p>
        <el-image v-for="(item,index) in customeText.imageUrl" :key="index" style="width: 100px; height: 100px;margin:0 12px 12px 0" :fit="fit" :src="item" :preview-src-list="customeText.imageUrl"> </el-image>
      </div>
    </div>
    <div class="label">Order Items</div>
    <el-table :data="orderItems" style="width: 100%">
    <el-table-column prop="color" label="Color" width="120"></el-table-column>
    <el-table-column prop="size" label="Size"></el-table-column>
    <el-table-column prop="customerBarcode" label="Customer Barcode"></el-table-column>
    <el-table-column prop="customerSku" label="Customer SKU"></el-table-column>
    <el-table-column prop="imageUrls" label="Image URLs">
      <template slot-scope="scope">
        <div class="img f--c">
          <el-image
            v-for="(url, index) in (scope.row.showAllImages ? scope.row.imageUrls : scope.row.imageUrls.slice(0, 3))"
            :key="index"
            :src="url"
            :preview-src-list="scope.row.imageUrls"
            style="max-width: 50px; max-height: 50px; margin-right: 5px; cursor: pointer;"
          ></el-image>
          <el-popover
            placement="right"
            width="310"
            trigger="hover">
            <div>
              <el-image
                v-for="(url, index) in scope.row.imageUrls"
                :key="index"
                :src="url"
                :preview-src-list="scope.row.imageUrls"
                style="max-width: 50px; max-height: 50px; margin-right: 5px; cursor: pointer;"
              ></el-image>
            </div>
            <i slot="reference" class="el-icon-d-arrow-right"></i>
          </el-popover>
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="material" label="Material"></el-table-column>
    <el-table-column
      prop="print"
      label="Print">
      <template slot-scope="scope">
        <el-tooltip placement="top">
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ scope.row.print }}
          </div>
          <div slot="content" style="width: 280px;">{{ scope.row.print }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="quantity" label="Quantity"></el-table-column>
    <el-table-column
      prop="remark"
      label="Remark">
      <template slot-scope="scope">
        <el-tooltip placement="top">
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ scope.row.remark }}
          </div>
          <div slot="content" style="width: 500px;">{{ scope.row.remark }}</div>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column
      prop="uniqueCodeType"
      label="Unique Code Type">
      <template slot-scope="scope">
        {{ displayUniqueCodeType(scope.row.uniqueCodeType) }}
      </template>
    </el-table-column>
  </el-table>

    <div class="f otherModule">
      <div class="customerEmail">
        <div class="topLabel f f-b f--c">
          <span>客户邮件</span>
          <el-button type="primary" @click="sendEmailVisible = true">发送邮件</el-button>
        </div>
        <div class="info f f--c">
          <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" class="avatar">
          <span class="name">Jun</span>
          <span>160001225@163.com</span>
        </div>
      </div>
      <!-- <div class="feedback">
        <div class="topLabel f f-b f--c">
          <span>开发部反馈</span>
          <el-button type="primary">新增反馈</el-button>
        </div>
      </div> -->
      <feedback :productCustomId="productCustomId"></feedback>
    </div>
    <el-dialog
      title="发送邮件"
      :visible.sync="sendEmailVisible"
      width="1000px"
      :before-close="sendEmailClose">
      <div style="margin-bottom:10px">
        <el-input placeholder="邮件标题" v-model="sendEmailForm.title"></el-input>
      </div>
      <div>
        <RichEditor :value="sendEmailForm.content" style="width:100%" @input="inputRichEditorValue" ref="tinymce"></RichEditor>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendEmailVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendEmailSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import API from '@/api'
import RichEditor from '@/views/operation/copywriting/components/RichEditor'
import feedback from './components/feedback.vue'
import { materialList } from '@/utils/material.js'
import { PODImageMap } from './data'
export default {
  components: {
    RichEditor,
    feedback
  },
  data() {
    return {
      fit: 'cover',
      customeDetail: {},
      customeText: {},
      orderItems: [],
      productCustomId: undefined,
      sendEmailVisible: false,
      sendEmailForm: {
        title: undefined,
        content: undefined
      },
      addParams: {
        productCustomId: undefined,
        parentId: undefined,
        title: undefined,
        content: undefined,
        imgUrl: undefined
      },
      materialSelectList: _.sortBy(materialList, e => e.en),
      PODImageMap
    }
  },
  filters: {
    materialHandle(value) {
      return materialList.find(e => +e.value === +value).en
    },
    podStyleImage(value) {
      const target = PODImageMap.find(e => +e.value === +value)
      return target.url
    },
    podStyleText(value) {
      const target = PODImageMap.find(e => +e.value === +value)
      return target.text
    }
  },
  created() {
    this.productCustomId = this.$route.query.id
    this.getProductCustomDetail()
  },
  methods: {
    //获取详情
    getProductCustomDetail() {
      API.getProductCustomDetail(this.$route.query.id).then(res => {
        this.customeDetail = res.data
        this.customeText = res.data.text
        this.customeText.imageUrl=_.get(res,'data.text.imageUrl').split(',') || []
        if (this.customeText.orderItemsJson && this.customeText.orderItemsJson.length > 0) {
          this.orderItems = JSON.parse(this.customeText.orderItemsJson);
        }
      })
    },
    tableRowClassName() {
      return 'background-color:rgba(0, 0, 0, 0.02);font-size:14px;font-weight:500;color:#10141d;'
    },
    sendEmailClose() {
      this.sendEmailVisible = false
    },
    inputRichEditorValue(value) {
      this.addParams.content = value
    },
    sendEmailSubmit() {
      const params = {...this.sendEmailForm}
      params.productCustomId = this.productCustomId
      params.parentId = 0
      API.customCommentSave(params).then(()=>{
        this.$message.success('评论成功')
        this.sendEmailClose()
      })
    },
    displayUniqueCodeType(type) {
      // Replace values based on your mapping
      switch (type) {
        case '1':
          return 'Barcode';
        case '2':
          return 'QR Code';
        case '3':
          return 'Dual code';
        case '4':
          return 'Plain text';
        default:
          return '';
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  height: calc(100vh - 65px);

  .img {
    .el-icon-d-arrow-right {
      font-size: 24px;
    }
  }
}
.part-container {
  background: #ffffff;
  padding: 15px 30px;
  margin-bottom: 15px;
  .part-head {
    margin-bottom: 20px;
    .part-title {
      font-size: 18px;
      font-weight: 500;
      margin-right: 16px;
    }
  }
  .typeTitle {
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
    margin-bottom: 30px
  }
  .part-main {
    .image-part-title {
      margin-bottom: 10px;
    }
  }
}
/deep/.el-form-item {
  width: 60%;
}
.image-box {
  width: 100px;
  height: 100px;
  overflow: hidden;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.item-box {
  font-size: 14px;
  line-height: 26px;
  padding-bottom: 20px;
  .label {
    color: #747a87;
    width: 100%;
  }
  .info {
    width: 100%;
    word-wrap:break-word;
    color: #10141d;
  }
}
.otherModule {
  margin-top: 30px;//添加边距
  .customerEmail{
    flex:4;
    background-color: #fff;
    margin-right:15px;
    .info {
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      padding: 20px;
      .avatar {
        height: 38px;
        width: 38px;
        display: block;
        border-radius: 50%;
        margin-right: 10px;
      }
      .name{
        font-weight: bold;
        margin-right: 30px;
      }
    }
  }
  .topLabel{
    padding: 14px 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
}
.materialItem {
  padding: 8px 14px;
  background-color: #D9D9D947;
  border-radius: 30px;
  margin-right: 8px;
  line-height: 22px;
  margin-bottom: 10px;
}
.printImageBox {
  >div{
    padding: 14px 6px;
    border: 1px solid #CDD4DD;
    margin-right: 30px;
    margin-bottom: 20px;
    border-radius: 6px;
  }
}
</style>
